import { all } from 'redux-saga/effects';
import danhMucSagas from '../sagas/danhmuc-saga';
export default function* rootSagas() {
    yield all([danhMucSagas()]);
}
